(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goy-matrix"] && !Shopify.designMode) return;
  try {
    
  class GoyMatrixStorefront extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.canvas = this.querySelector('.gm-rain');
      this.ctx = this.canvas.getContext('2d', { alpha: false });
      this.entry = this.querySelector('.gm-entry');
      this.shop = this.querySelector('.gm-shop');
      this.typed = this.querySelector('.gm-typed');
      this.enterButton = this.querySelector('[data-enter]');
      this.replayButton = this.querySelector('[data-replay]');
      this.motionButtons = [...this.querySelectorAll('[data-motion]')];
      this.welcome = this.dataset.welcome || 'WELCOME GOY';
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motionQuery.matches;
      this.characters = Array.from('アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン012345789<>+*{}');
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.enterButton.addEventListener('click', () => this.enter(), options);
      this.replayButton.addEventListener('click', () => this.replay(), options);
      this.motionButtons.forEach(button => button.addEventListener('click', () => this.toggleMotion(), options));
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.resize(), 100);
      }, options);
      document.addEventListener('visibilitychange', () => this.updateAnimation(), options);
      this.motionQuery.addEventListener('change', event => {
        this.paused = event.matches;
        this.updateMotionControls();
        this.finishTyping();
        this.updateAnimation();
      }, options);
      this.addEventListener('keydown', event => {
        if (this.entered || event.key !== 'Tab') return;
        const first = this.enterButton;
        const last = this.entry.querySelector('[data-motion]');
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      this.resize();
      this.updateMotionControls();
      this.openEntry(false);
      this.updateAnimation();
      document.addEventListener('shopify:block:select', () => this.enter(), options);
      if (this.dataset.designMode === 'true') this.enter();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      cancelAnimationFrame(this.animationFrame);
      clearTimeout(this.typingTimer);
      clearTimeout(this.resizeTimer);
      clearTimeout(this.hideTimer);
      if (!this.entered && this.savedOverflow !== undefined) document.body.style.overflow = this.savedOverflow;
      this.initialized = false;
    }

    resize() {
      if (!this.ctx) return;
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
      this.canvas.width = Math.ceil(this.width * ratio);
      this.canvas.height = Math.ceil(this.height * ratio);
      this.ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      this.fontSize = this.width < 600 ? 15 : 17;
      const spacing = this.fontSize * 1.22;
      this.streams = Array.from({ length: Math.ceil(this.width / spacing) }, (_, index) => {
        const length = 9 + Math.floor(Math.random() * 24);
        return {
          x: index * spacing,
          y: Math.random() * (this.height + length * this.fontSize),
          speed: 35 + Math.random() * 90,
          length,
          brightness: .35 + Math.random() * .65,
          glyphs: Array.from({ length }, () => this.randomCharacter())
        };
      });
      this.draw(0);
    }

    randomCharacter() {
      return this.characters[Math.floor(Math.random() * this.characters.length)];
    }

    draw(delta) {
      if (!this.ctx) return;
      const ctx = this.ctx;
      ctx.globalAlpha = 1;
      ctx.fillStyle = '#000000';
      ctx.fillRect(0, 0, this.width, this.height);
      ctx.font = `${this.fontSize}px monospace`;
      ctx.textBaseline = 'top';
      for (const stream of this.streams) {
        stream.y += stream.speed * delta;
        if (stream.y - stream.length * this.fontSize > this.height) {
          stream.y = -this.fontSize;
          stream.speed = 35 + Math.random() * 90;
        }
        for (let i = 0; i < stream.length; i++) {
          const y = stream.y - i * this.fontSize;
          if (y < -this.fontSize || y > this.height) continue;
          ctx.globalAlpha = Math.pow(1 - i / stream.length, 1.8) * stream.brightness;
          ctx.fillStyle = i === 0 ? '#cbffd3' : i < 4 ? '#44ff77' : '#0cc343';
          if (delta && Math.random() < .015) stream.glyphs[i] = this.randomCharacter();
          ctx.fillText(stream.glyphs[i], stream.x, y);
        }
      }
      ctx.globalAlpha = 1;
    }

    updateAnimation() {
      cancelAnimationFrame(this.animationFrame);
      this.previousFrame = 0;
      if (this.paused || document.hidden || !this.isConnected) return;
      const tick = timestamp => {
        if (!this.isConnected || this.paused || document.hidden) return;
        if (!this.previousFrame) this.previousFrame = timestamp;
        const elapsed = timestamp - this.previousFrame;
        if (elapsed >= 1000 / 24) {
          this.draw(Math.min(elapsed / 1000, .08));
          this.previousFrame = timestamp;
        }
        this.animationFrame = requestAnimationFrame(tick);
      };
      this.animationFrame = requestAnimationFrame(tick);
    }

    updateMotionControls() {
      this.classList.toggle('gm-paused', this.paused);
      for (const button of this.motionButtons) {
        button.textContent = this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        button.setAttribute('aria-pressed', String(this.paused));
      }
    }

    toggleMotion() {
      this.paused = !this.paused;
      this.updateMotionControls();
      if (this.paused) this.finishTyping();
      this.updateAnimation();
    }

    finishTyping() {
      clearTimeout(this.typingTimer);
      this.typed.textContent = this.welcome;
    }

    typeWelcome() {
      clearTimeout(this.typingTimer);
      if (this.paused) {
        this.finishTyping();
        return;
      }
      const letters = Array.from(this.welcome);
      let count = 0;
      this.typed.textContent = '';
      const type = () => {
        if (this.entered || !this.isConnected) return;
        this.typed.textContent = letters.slice(0, ++count).join('');
        if (count < letters.length) this.typingTimer = setTimeout(type, 100 + Math.random() * 65);
      };
      this.typingTimer = setTimeout(type, 250);
    }

    openEntry(focus) {
      clearTimeout(this.hideTimer);
      this.entered = false;
      this.savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.entry.hidden = false;
      this.entry.inert = false;
      this.entry.removeAttribute('aria-hidden');
      this.shop.inert = true;
      this.shop.setAttribute('aria-hidden', 'true');
      this.classList.remove('gm-entered');
      this.typeWelcome();
      if (focus) this.enterButton.focus({ preventScroll: true });
    }

    enter() {
      if (this.entered) return;
      this.entered = true;
      this.finishTyping();
      this.shop.inert = false;
      this.shop.removeAttribute('aria-hidden');
      this.entry.inert = true;
      this.entry.setAttribute('aria-hidden', 'true');
      this.classList.add('gm-entered');
      document.body.style.overflow = this.savedOverflow ?? '';
      this.querySelector('.gm-drop').focus({ preventScroll: true });
      this.hideTimer = setTimeout(() => { this.entry.hidden = true; }, this.motionQuery.matches ? 0 : 500);
    }

    replay() {
      window.scrollTo({ top: 0, behavior: 'instant' });
      this.openEntry(true);
    }
  }

  if (!customElements.get('goy-matrix-storefront')) customElements.define('goy-matrix-storefront', GoyMatrixStorefront);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
